import React from "react";
import { Label } from "../ui/label";
import { Input } from "../ui/input";
import { cn } from "../../lib/utils";

export function FormField({ label, error, required, children, testId, hint, wrapperClassName }) {
  return (
    <div className={cn("space-y-1.5", wrapperClassName)}>
      <Label>
        {label}
        {required && <span className="text-danger"> *</span>}
      </Label>
      {children}
      {hint && !error && <p className="text-[11px] text-text-muted">{hint}</p>}
      {error && (
        <p className="text-[11px] font-medium text-danger" data-testid={testId ? `${testId}-error` : undefined}>
          {error}
        </p>
      )}
    </div>
  );
}

export function TextField({ label, error, required, hint, testId, wrapperClassName, className, ...inputProps }) {
  return (
    <FormField label={label} error={error} required={required} hint={hint} testId={testId} wrapperClassName={wrapperClassName}>
      <Input
        data-testid={testId}
        className={cn(error && "border-danger focus:ring-danger", className)}
        {...inputProps}
      />
    </FormField>
  );
}
